// extracted by mini-css-extract-plugin
module.exports = {"x-sider":"style_x-sider__3cXyW","menu-actions":"style_menu-actions__2D5Z8","menu-search":"style_menu-search__33vcb","menu":"style_menu__2T1Xj"};